import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import {
    Box,
    Button,
    Divider,
    IconButton,
    TextField,
    Typography,
} from "@mui/material";
import {useMemo, useState} from "react";
import {X} from "lucide-react";
import {createCategory} from "../../api/api";

export default function CreateCategoryDialog({open, onClose, onCreated}) {
    const [categoryName, setCategoryName] = useState("")
    const [isSaving, setIsSaving] = useState(false)
    const [errorMsg, setErrorMsg] = useState(null)

    const canCreate = useMemo(() => categoryName.trim().length > 0, [categoryName])

    const handleCreate = async () => {
        if (!canCreate || isSaving) return
        setIsSaving(true)
        setErrorMsg(null)
        try {
            await createCategory(categoryName.trim())
            setCategoryName("")
            if (onCreated) {
                await onCreated()
            } else if (onClose) {
                onClose()
            }
        } catch (e) {
            console.error(e)
            setErrorMsg('No se pudo crear la categoría.')
        } finally {
            setIsSaving(false)
        }
    }

    const handleClose = () => {
        if (isSaving) return
        setErrorMsg(null)
        if (onClose) onClose()
    }

    return (
        <Dialog
            open={Boolean(open)}
            onClose={handleClose}
            fullWidth
            maxWidth="xs"
            BackdropProps={{
                sx: {
                    backdropFilter: 'blur(6px)',
                    backgroundColor: 'rgba(0,0,0,0.35)',
                },
            }}
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    boxShadow: 24,
                    bgcolor: 'white',
                },
            }}
        >
            <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 3, pt: 2}}>
                <Typography variant="h6" sx={{fontWeight: 600, color: 'black'}}>
                    Crear Categoría
                </Typography>
                <IconButton aria-label="Close" onClick={handleClose} size="small">
                    <X size={18} />
                </IconButton>
            </Box>

            <Divider sx={{mt: 2}} />

            <DialogContent sx={{px: 3, py: 2}}>
                <Typography sx={{mb: 1.5, color: 'black'}}>
                    Escribe el nombre de la nueva categoria
                </Typography>
                <TextField
                    fullWidth
                    value={categoryName}
                    onChange={(e) => setCategoryName(e.target.value)}
                    placeholder="Nombre de la categoria"
                    size="small"
                    autoFocus
                    disabled={isSaving}
                    error={Boolean(errorMsg)}
                    helperText={errorMsg || ' '}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                        },
                    }}
                />
            </DialogContent>

            <Divider />

            <DialogActions sx={{px: 3, py: 2}}>
                <Button
                    variant="contained"
                    onClick={handleCreate}
                    disabled={!canCreate || isSaving}
                    sx={{textTransform: 'none'}}
                >
                    Crear
                </Button>
            </DialogActions>
        </Dialog>
    )
}
